import React from 'react';
import { useTranslation } from 'react-i18next';

import { FeatureItem, FeatureList } from './styled';
import { IconCheck } from './icons';

type PlanFeatureListProps = {
  maxCommunities: number;
  maxGroups: number;
  maxMembers: number;
  maxStorage: number;
  extras?: string[];
  style?: React.CSSProperties;
};

const PlanFeatureList = ({
  maxCommunities,
  maxGroups,
  maxMembers,
  maxStorage,
  extras = [],
  style,
}: PlanFeatureListProps) => {
  const { t } = useTranslation();

  return (
    <FeatureList style={style}>
      <FeatureItem>
        <IconCheck />
        {t('subscriptions.profile.plan.featureCommunities', {
          count: maxCommunities,
        })}
      </FeatureItem>
      <FeatureItem>
        <IconCheck />
        {t('subscriptions.profile.plan.featureSchedulers', {
          count: maxGroups,
        })}
      </FeatureItem>
      <FeatureItem>
        <IconCheck />
        {t('subscriptions.profile.plan.featureMembers', {
          count: maxMembers,
        })}
      </FeatureItem>
      <FeatureItem>
        <IconCheck />
        {t('subscriptions.profile.plan.featureStorage', {
          count: maxStorage,
        })}
      </FeatureItem>
      {extras.map((line) => (
        <FeatureItem key={line}>
          <IconCheck />
          {line}
        </FeatureItem>
      ))}
    </FeatureList>
  );
};

export default PlanFeatureList;
